export enum Level {
    'seniorManager' = 'seniorManager',
    'manager' = 'manager',
    'teamLead' = 'teamLead',
    'staff' = 'staff',
    'departmentManager' = 'departmentManager',
    'generalManager' = 'generalManager',
    'director' = 'director',
}

export type LevelTypes = 'staff' | 'teamLead' | 'seniorManager' | 'manager' | 'departmentManager' | 'generalManager' | 'director' ;
